import { cssVar } from '../../styling';

import { CoreUICSSVariable, CoreUICSSVariablesObject, CoreUINamespace, CoreUITokensObject } from './tokens.types';

const coreuiNamespace: CoreUINamespace = 'coreui';

const getCSSCustomPropertyFromTokenName = <TokenName extends string, LocalNamespace extends string>(
  tokenName: TokenName,
  localNamespace: LocalNamespace
): CoreUICSSVariable<LocalNamespace, TokenName> => `--${coreuiNamespace}-${localNamespace}-${tokenName}`;

interface CreateTokensReturnValue<TokenName extends string, LocalNamespace extends string> {
  readonly tokens: CoreUITokensObject<LocalNamespace, TokenName>;
  readonly cssVariables: CoreUICSSVariablesObject<LocalNamespace, TokenName>;
}
type CreateTokens = <TokenName extends string, LocalNamespace extends string>(
  keys: TokenName[],
  localNamespace: LocalNamespace
) => CreateTokensReturnValue<TokenName, LocalNamespace>;

export const createTokens: CreateTokens = <TokenName extends string, LocalNamespace extends string>(
  keys: TokenName[],
  localNamespace: LocalNamespace
) => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const tokensObject = { tokens: {}, cssVariables: {} } as CreateTokensReturnValue<TokenName, LocalNamespace>;
  keys.forEach((key) => {
    const token = getCSSCustomPropertyFromTokenName(key, localNamespace);
    tokensObject.cssVariables[key] = token;
    tokensObject.tokens[key] = cssVar(token);
  });

  return tokensObject;
};
